import uniqid from 'uniqid'
import _cloneDeep from 'lodash.clonedeep'

import types from './types'
import detailsTypes from '../details/types'
import { saveActionDetail, updateModalError as updateDetailsModalError, updateActionsErrors } from '../details/actions'
import { getActionsErrors, typesData } from 'components/SmartChatView/utils'

const setAlternatives = (payload = {}) => (dispatch, getStore) => {
  const { alternativesId, alternativesData } = payload
  const { alternatives, error } = getStore().smartchatAlternatives

  if (error) dispatch(updateError(null))

  const _alternatives = _cloneDeep(alternatives)
  if (alternativesData) {
    _alternatives.push({ id: alternativesId, ...alternativesData })
  } else {
    _alternatives.push({ id: alternativesId, questionText: '', alternativeList: [] })
  }

  dispatch({
    type: types.SMARTCHAT_ALTERNATIVES_UPDATE,
    payload: _alternatives
  })
}

const updateAlternatives = (payload = {}) => (dispatch, getStore) => {
  const { alternativesId, modalActionRef, actionDetail } = payload
  const { alternatives, error } = getStore().smartchatAlternatives

  if (error) dispatch(updateError(null))

  const _alternatives = _cloneDeep(alternatives)
  const alternativesIndex = _alternatives.findIndex(alternatives => alternatives.id === alternativesId)
  if (alternativesIndex === -1) return
  const alternativeIndex = _alternatives[alternativesIndex].alternativeList.findIndex(alternative => alternative.id === modalActionRef.alternativeId)
  if (alternativeIndex === -1) return

  if (modalActionRef.actionType === 'botAction') {
    if (modalActionRef.fromActionType) {
      _alternatives[alternativesIndex].alternativeList[alternativeIndex].alternativeActions.onProcess[0].actionList[modalActionRef.fromActionIndex].botActionList[modalActionRef.actionIndex] = actionDetail
    } else {
      _alternatives[alternativesIndex].alternativeList[alternativeIndex].alternativeActions.onNewProcess.actionList[modalActionRef.actionIndex] = actionDetail
    }
  }
  if (typesData.clientOperatorActionTypes.includes(modalActionRef.actionType)) {
    _alternatives[alternativesIndex].alternativeList[alternativeIndex].alternativeActions.onProcess[0].actionList[modalActionRef.actionIndex] = actionDetail
  }

  dispatch({
    type: types.SMARTCHAT_ALTERNATIVES_UPDATE,
    payload: _alternatives
  })
}

const deleteAlternatives = (payload = {}) => (dispatch, getStore) => {
  const { alternativesId } = payload
  const { alternatives } = getStore().smartchatAlternatives

  const _alternatives = _cloneDeep(alternatives)
  const alternativesIndex = _alternatives.findIndex(alternatives => alternatives.id === alternativesId)
  if (alternativesIndex === -1) return

  _alternatives.splice(alternativesIndex, 1)

  dispatch({
    type: types.SMARTCHAT_ALTERNATIVES_UPDATE,
    payload: _alternatives
  })
}

const saveAlternatives = (payload = {}) => (dispatch, getStore) => {
  const { alternativesId, fromAlternativesId, previewActionRef, onFinish } = payload
  const {
    smartchatAlternatives : { alternatives, alternativesActionDetail, alternativesModalActionRef, alternativesActionsErrors, error },
    smartchatDetails: { actionDetail, modalActionRef, actionsErrors, modalError }
  } = getStore()

  const alternativesIndex = alternatives.findIndex(alternatives => alternatives.id === alternativesId)
  if (alternativesIndex === -1) return

  /* INICIO COMPROBACIÓN DE DATOS */
  // Comprueba que se haya ingresado una pregunta
  if (!alternatives[alternativesIndex].questionText) {
    dispatch(updateError({
      origin: '[Redux] saveAlternatives',
      message: 'dashboard_error_question-empty'
    }))
    return
  }
  // Comprueba que se haya ingresado al menos una respuesta
  if (!alternatives[alternativesIndex].alternativeList.length) {
    dispatch(updateError({
      origin: '[Redux] saveAlternatives',
      message: 'smartchat_error_alternatives_answersEmpty'
    }))
    return
  }
  /* FIN COMPROBACIÓN DE DATOS */

  if (fromAlternativesId) {
    const actionsErrorsIndex = alternativesActionsErrors.findIndex(actionsErrors => actionsErrors.alternativesId === alternativesId)
    if (alternativesActionsErrors[actionsErrorsIndex]?.showAlternatives) {
      const _actionsErrors = _cloneDeep(alternativesActionsErrors[actionsErrorsIndex])
      delete _actionsErrors.showAlternatives
      dispatch(updateAlternativesActionsErrors({ alternativesId, actionsErrors: _actionsErrors }))
    }
    if (error) dispatch(updateError(null))

    const _alternativesActionDetail = _cloneDeep(alternativesActionDetail)
    const fromActionDetailIndex = _alternativesActionDetail.findIndex(actionDetail => actionDetail.alternativesId === fromAlternativesId)
    if (fromActionDetailIndex === -1) return

    _alternativesActionDetail[fromActionDetailIndex].actionDetail.eventData = {
      questionText: alternatives[alternativesIndex].questionText,
      alternativeList: alternatives[alternativesIndex].alternativeList,
      buttons: alternatives[alternativesIndex].buttons
    }

    dispatch({
      type: types.SMARTCHAT_ALTERNATIVES_UPDATE_ACTION_DETAIL,
      payload: _alternativesActionDetail
    })

    if (!alternativesModalActionRef.find(modalActionRef => modalActionRef.alternativesId === fromAlternativesId) && previewActionRef) {
      dispatch(saveAlternativesActionDetail({
        alternativesId: fromAlternativesId,
        previewActionRef: { ...previewActionRef, mode: 'update' }
      }))
    }

    onFinish && typeof onFinish === 'function' && onFinish()
  } else {
    if (actionsErrors.showAlternatives) {
      const _actionsErrors = _cloneDeep(actionsErrors)
      delete _actionsErrors.showAlternatives
      dispatch(updateActionsErrors(_actionsErrors))
    }
    if (modalError) dispatch(updateDetailsModalError(null))

    const _actionDetail = _cloneDeep(actionDetail)

    _actionDetail.eventData = {
      questionText: alternatives[alternativesIndex].questionText,
      alternativeList: alternatives[alternativesIndex].alternativeList,
      buttons: alternatives[alternativesIndex].buttons
    }

    dispatch({
      type: detailsTypes.SMARTCHAT_DETAILS_SET_ACTION_DETAIL,
      payload: _actionDetail
    })

    if (!Object.keys(modalActionRef).length && previewActionRef) {
      dispatch(saveActionDetail({
        previewActionRef: { ...previewActionRef, mode: 'update' },
        previewActionDetail: _actionDetail,
        onFinish
      }))
    } else {
      onFinish && typeof onFinish === 'function' && onFinish()
    }
  }
}

const setAlternative = (payload = {}) => (dispatch, getStore) => {
  const { alternativesId, alternativeText, onFinish } = payload
  const { alternatives, modalError, error } = getStore().smartchatAlternatives

  if (modalError) dispatch(updateModalError(null))

  if (!alternativeText) {
    dispatch(updateModalError({
      origin: '[Redux] setAlternative',
      message: 'smartchat_alternatives_answerEmpty'
    }))
    return
  }

  if (error) dispatch(updateError(null))

  const _alternatives = _cloneDeep(alternatives)
  const alternativesIndex = _alternatives.findIndex(alternatives => alternatives.id === alternativesId)
  if (alternativesIndex === -1) return

  if (_alternatives[alternativesIndex].alternativeList.some(alternative => alternative.alternativeText === alternativeText)) {
    dispatch(updateModalError({
      origin: '[Redux] setAlternative',
      message: 'smartchat_alternatives_answerExist'
    }))
    return
  }

  _alternatives[alternativesIndex].alternativeList.push({
    id: uniqid('alternative-'),
    alternativeText,
    alternativeActions: {
      onNewProcess: { actionList: [] },
      onProcess: [{ actionList: [] }],
      onLeaveProcess: { actionList: [] }
    }
  })

  dispatch({
    type: types.SMARTCHAT_ALTERNATIVES_UPDATE,
    payload: _alternatives
  })

  onFinish && typeof onFinish === 'function' && onFinish()
}

const deleteAlternative = (payload = {}) => (dispatch, getStore) => {
  const { alternativesId, alternativeId, onFinish } = payload
  const { alternatives } = getStore().smartchatAlternatives

  const _alternatives = _cloneDeep(alternatives)
  const alternativesIndex = _alternatives.findIndex(alternatives => alternatives.id === alternativesId)
  if (alternativesIndex === -1) return
  const alternativeIndex = _alternatives[alternativesIndex].alternativeList.findIndex(alternative => alternative.id === alternativeId)
  if (alternativeIndex === -1) return

  _alternatives[alternativesIndex].alternativeList.splice(alternativeIndex, 1)

  dispatch({
    type: types.SMARTCHAT_ALTERNATIVES_UPDATE,
    payload: _alternatives
  })

  onFinish && typeof onFinish === 'function' && onFinish()
}

const updateAlternativesButtons = (payload = {}) => (dispatch, getStore) => {
  const { alternativesId, buttons } = payload
  const { alternatives, error } = getStore().smartchatAlternatives

  if (error) dispatch(updateError(null))

  const _alternatives = _cloneDeep(alternatives)
  const alternativesIndex = _alternatives.findIndex(alternatives => alternatives.id === alternativesId)
  if (alternativesIndex === -1) return

  _alternatives[alternativesIndex].buttons = buttons

  dispatch({
    type: types.SMARTCHAT_ALTERNATIVES_UPDATE,
    payload: _alternatives
  })
}

const updateAlternativesQuestion = (payload = {}) => (dispatch, getStore) => {
  const { alternativesId, questionText } = payload
  const { alternatives, error } = getStore().smartchatAlternatives

  if (error) dispatch(updateError(null))

  const _alternatives = _cloneDeep(alternatives)
  const alternativesIndex = _alternatives.findIndex(alternatives => alternatives.id === alternativesId)
  if (alternativesIndex === -1) return

  _alternatives[alternativesIndex].questionText = questionText

  dispatch({
    type: types.SMARTCHAT_ALTERNATIVES_UPDATE,
    payload: _alternatives
  })
}

const updateAlternativeText = (payload = {}) => (dispatch, getStore) => {
  const { alternativesId, alternativeText, alternativeId, onFinish } = payload
  const { alternatives } = getStore().smartchatAlternatives

  if (!alternativeText) {
    dispatch(updateModalError({
      origin: '[Redux] updateAlternativeText',
      message: 'smartchat_alternatives_answerEmpty'
    }))
    return
  }

  const _alternatives = _cloneDeep(alternatives)
  const alternativesIndex = _alternatives.findIndex(alternatives => alternatives.id === alternativesId)
  if (alternativesIndex === -1) return

  if (_alternatives[alternativesIndex].alternativeList.some(alternative => alternative.alternativeText === alternativeText)) {
    dispatch(updateModalError({
      origin: '[Redux] setAlternative',
      message: 'smartchat_alternatives_answerExist'
    }))
    return
  }

  const alternativeIndex = _alternatives[alternativesIndex].alternativeList.findIndex(alternative => alternative.id === alternativeId)
  if (alternativeIndex === -1) return

  _alternatives[alternativesIndex].alternativeList[alternativeIndex].alternativeText = alternativeText

  dispatch({
    type: types.SMARTCHAT_ALTERNATIVES_UPDATE,
    payload: _alternatives
  })

  onFinish && typeof onFinish === 'function' && onFinish()
}

const setAlternativesModalActionRef = (payload) => (dispatch, getStore) => {
  const { alternativesModalActionRef } = getStore().smartchatAlternatives

  const _alternativesModalActionRef = _cloneDeep(alternativesModalActionRef)
  _alternativesModalActionRef.push(payload)

  dispatch({
    type: types.SMARTCHAT_ALTERNATIVES_UPDATE_MODAL_ACTION_REF,
    payload: _alternativesModalActionRef
  })
}

const updateAlternativesModalActionRef = (payload) => (dispatch, getStore) => {
  const { alternativesId, modalActionRef } = payload
  const { alternativesModalActionRef } = getStore().smartchatAlternatives

  const _alternativesModalActionRef = _cloneDeep(alternativesModalActionRef)
  const modalActionRefIndex = _alternativesModalActionRef.findIndex(modalActionRef => modalActionRef.alternativesId === alternativesId)
  if (modalActionRefIndex === -1) return

  _alternativesModalActionRef[modalActionRefIndex] = modalActionRef

  dispatch({
    type: types.SMARTCHAT_ALTERNATIVES_UPDATE_MODAL_ACTION_REF,
    payload: _alternativesModalActionRef
  })
}

const deleteAlternativesModalActionRef = (payload = {}) => (dispatch, getStore) => {
  const { alternativesId } = payload
  const { alternativesModalActionRef } = getStore().smartchatAlternatives

  const _alternativesModalActionRef = _cloneDeep(alternativesModalActionRef)
  const modalActionRefIndex = _alternativesModalActionRef.findIndex(modalActionRef => modalActionRef.alternativesId === alternativesId)
  if (modalActionRefIndex === -1) return

  _alternativesModalActionRef.splice(modalActionRefIndex, 1)

  dispatch({
    type: types.SMARTCHAT_ALTERNATIVES_UPDATE_MODAL_ACTION_REF,
    payload: _alternativesModalActionRef
  })
}

const setAlternativesInitialActionDetail = (payload = {}) => (dispatch, getStore) => {
  const { alternativesId, eventType, eventData, actionProperties } = payload
  const { alternativesModalActionRef, alternativesActionDetail } = getStore().smartchatAlternatives

  const modalActionRef = alternativesModalActionRef.find(modalActionRef => modalActionRef.alternativesId === alternativesId)
  let actionDetail = {}

  if (modalActionRef.actionType === 'botAction') {
    actionDetail = {
      eventType,
      actionOrder: 0,
      eventData: eventData || {}
    }
  }
  if (typesData.clientOperatorActionTypes.includes(modalActionRef.actionType)) {
    actionDetail = {
      actionType: modalActionRef.actionType,
      actionOrder: 0,
      actionSubtype: eventType,
      actionProperties: actionProperties || {},
      botActionList: []
    }
  }

  const _alternativesActionDetail = _cloneDeep(alternativesActionDetail)
  _alternativesActionDetail.push({ alternativesId, actionDetail })

  dispatch({
    type: types.SMARTCHAT_ALTERNATIVES_UPDATE_ACTION_DETAIL,
    payload: _alternativesActionDetail
  })
}

const setAlternativesActionDetail = (payload = {}) => (dispatch, getStore) => {
  const { alternativesId, actionDetail } = payload
  const { alternativesActionDetail } = getStore().smartchatAlternatives

  const _alternativesActionDetail = _cloneDeep(alternativesActionDetail)
  _alternativesActionDetail.push({ alternativesId, actionDetail })

  dispatch({
    type: types.SMARTCHAT_ALTERNATIVES_UPDATE_ACTION_DETAIL,
    payload: _alternativesActionDetail
  })
}

const deleteAlternativesActionDetail = (payload = {}) => (dispatch, getStore) => {
  const { alternativesId } = payload
  const { alternativesActionDetail } = getStore().smartchatAlternatives

  const _alternativesActionDetail = _cloneDeep(alternativesActionDetail)
  const actionDetailIndex = _alternativesActionDetail.findIndex(actionDetail => actionDetail.alternativesId === alternativesId)
  if (actionDetailIndex === -1) return

  _alternativesActionDetail.splice(actionDetailIndex, 1)

  dispatch({
    type: types.SMARTCHAT_ALTERNATIVES_UPDATE_ACTION_DETAIL,
    payload: _alternativesActionDetail
  })
}

const setAlternativesActionValue = (payload = {}) => (dispatch, getStore) => {
  const { alternativesId, actionValue } = payload
  const { alternativesModalActionRef, alternativesActionDetail } = getStore().smartchatAlternatives

  const modalActionRef = alternativesModalActionRef.find(modalActionRef => modalActionRef.alternativesId === alternativesId)

  const _alternativesActionDetail = _cloneDeep(alternativesActionDetail)
  const actionDetailIndex = _alternativesActionDetail.findIndex(actionDetail => actionDetail.alternativesId === alternativesId)
  if (actionDetailIndex === -1) return

  if (modalActionRef.actionType === 'botAction') {
    _alternativesActionDetail[actionDetailIndex].actionDetail.eventData = {
      ..._alternativesActionDetail[actionDetailIndex].actionDetail.eventData,
      ...actionValue
    }
  }
  if (typesData.clientOperatorActionTypes.includes(modalActionRef.actionType)) {
    _alternativesActionDetail[actionDetailIndex].actionDetail.actionProperties = {
      ..._alternativesActionDetail[actionDetailIndex].actionDetail.actionProperties,
      ...actionValue
    }
  }

  dispatch({
    type: types.SMARTCHAT_ALTERNATIVES_UPDATE_ACTION_DETAIL,
    payload: _alternativesActionDetail
  })
}

const saveAlternativesActionDetail = (payload = {}) => (dispatch, getStore) => {
  const { alternativesId, previewActionRef, onFinish } = payload
  const { alternatives, alternativesModalActionRef, alternativesActionDetail, actionsErrors, modalError } = getStore().smartchatAlternatives

  modalError && dispatch(updateModalError(null))

  const modalActionRef = alternativesModalActionRef.find(modalActionRef => modalActionRef.alternativesId === alternativesId) || previewActionRef
  const actionDetail = alternativesActionDetail.find(actionDetail => actionDetail.alternativesId === alternativesId)?.actionDetail || {}

  /* INICIO COMPROBACIÓN DE DATOS */
  if (modalActionRef.mode !== 'delete') {
    const errors = { ...actionsErrors, ...getActionsErrors({ actionType: modalActionRef.actionType, actionData: actionDetail }) }

    if (Object.keys(errors).length) {
      if (!actionsErrors || !Object.keys(actionsErrors).length) {  // Solo se notifican nuevos errores si no existen anteriores
        dispatch(setAlternativesActionsErrors({ alternativesId, actionsErrors: errors }))
      }
      dispatch(updateModalError({ origin: '[Redux] saveAlternativesActionDetail', message: 'dashboard_all-required-field' }))
      return
    }
  }
  /* FIN COMPROBACIÓN DE DATOS */

  const _alternatives = _cloneDeep(alternatives)
  const alternativesIndex = _alternatives.findIndex(alternatives => alternatives.id === alternativesId)
  if (alternativesIndex === -1) return
  const alternativeIndex = _alternatives[alternativesIndex].alternativeList.findIndex(alternative => alternative.id === modalActionRef.alternativeId)
  if (alternativeIndex === -1) return

  if (modalActionRef.actionType === 'botAction') {
    if (modalActionRef.fromActionType) {
      if (modalActionRef.mode === 'add') _alternatives[alternativesIndex].alternativeList[alternativeIndex].alternativeActions.onProcess[0].actionList[modalActionRef.fromActionIndex].botActionList.push(actionDetail)
      if (modalActionRef.mode === 'update') _alternatives[alternativesIndex].alternativeList[alternativeIndex].alternativeActions.onProcess[0].actionList[modalActionRef.fromActionIndex].botActionList[modalActionRef.actionIndex] = actionDetail
      if (modalActionRef.mode === 'delete') {
        const _actionList = _cloneDeep(_alternatives[alternativesIndex].alternativeList[alternativeIndex].alternativeActions.onProcess[0].actionList[modalActionRef.fromActionIndex].botActionList)
        _actionList.splice(modalActionRef.actionIndex, 1)
        _alternatives[alternativesIndex].alternativeList[alternativeIndex].alternativeActions.onProcess[0].actionList[modalActionRef.fromActionIndex].botActionList = _actionList
      }
    } else {
      if (modalActionRef.mode === 'add') _alternatives[alternativesIndex].alternativeList[alternativeIndex].alternativeActions.onNewProcess.actionList.push(actionDetail)
      if (modalActionRef.mode === 'update') _alternatives[alternativesIndex].alternativeList[alternativeIndex].alternativeActions.onNewProcess.actionList[modalActionRef.actionIndex] = actionDetail
      if (modalActionRef.mode === 'delete') {
        const _actionList = _cloneDeep(_alternatives[alternativesIndex].alternativeList[alternativeIndex].alternativeActions.onNewProcess.actionList)
        _actionList.splice(modalActionRef.actionIndex, 1)
        _alternatives[alternativesIndex].alternativeList[alternativeIndex].alternativeActions.onNewProcess.actionList = _actionList
      }
    }
  }
  if (typesData.clientOperatorActionTypes.includes(modalActionRef.actionType)) {
    if (modalActionRef.mode === 'add') _alternatives[alternativesIndex].alternativeList[alternativeIndex].alternativeActions.onProcess[0].actionList.push(actionDetail)
    if (modalActionRef.mode === 'update') _alternatives[alternativesIndex].alternativeList[alternativeIndex].alternativeActions.onProcess[0].actionList[modalActionRef.actionIndex] = actionDetail
    if (modalActionRef.mode === 'delete') {
      const _actionList = _cloneDeep(_alternatives[alternativesIndex].alternativeList[alternativeIndex].alternativeActions.onProcess[0].actionList)
      _actionList.splice(modalActionRef.actionIndex, 1)
      _alternatives[alternativesIndex].alternativeList[alternativeIndex].alternativeActions.onProcess[0].actionList = _actionList
    }
  }

  dispatch({
    type: types.SMARTCHAT_ALTERNATIVES_UPDATE,
    payload: _alternatives
  })

  onFinish && typeof onFinish === 'function' && onFinish()
}

const setAlternativesActionsErrors = (payload = {}) => (dispatch, getStore) => {
  const { alternativesId, actionsErrors } = payload
  const { alternativesActionsErrors } = getStore().smartchatAlternatives

  const _alternativesActionsErrors = _cloneDeep(alternativesActionsErrors)
  _alternativesActionsErrors.push({ ...actionsErrors, alternativesId })

  dispatch({
    type: types.SMARTCHAT_ALTERNATIVES_UPDATE_ACTIONS_ERRORS,
    payload: _alternativesActionsErrors
  })
}

const updateAlternativesActionsErrors = (payload = {}) => (dispatch, getStore) => {
  const { alternativesId, actionsErrors } = payload
  const { alternativesActionsErrors } = getStore().smartchatAlternatives

  const _alternativesActionsErrors = _cloneDeep(alternativesActionsErrors)
  const actionsErrorsIndex = _alternativesActionsErrors.findIndex(actionsErrors => actionsErrors.alternativesId === alternativesId)
  if (actionsErrorsIndex === -1) return

  _alternativesActionsErrors[actionsErrorsIndex] = actionsErrors

  dispatch({
    type: types.SMARTCHAT_ALTERNATIVES_UPDATE_ACTIONS_ERRORS,
    payload: _alternativesActionsErrors
  })
}

const deleteAlternativesActionsErrors = (payload = {}) => (dispatch, getStore) => {
  const { alternativesId } = payload
  const { alternativesActionsErrors } = getStore().smartchatAlternatives

  const _alternativesActionsErrors = _cloneDeep(alternativesActionsErrors)
  const actionsErrorsIndex = _alternativesActionsErrors.findIndex(actionsErrors => actionsErrors.alternativesId === alternativesId)
  if (actionsErrorsIndex === -1) return

  _alternativesActionsErrors.splice(actionsErrorsIndex, 1)

  dispatch({
    type: types.SMARTCHAT_ALTERNATIVES_UPDATE_ACTIONS_ERRORS,
    payload: _alternativesActionsErrors
  })
}

const updateModalError = (payload) => ({
  type: types.SMARTCHAT_ALTERNATIVES_UPDATE_MODAL_ERROR,
  payload
})

const updateLoading = (payload) => ({
  type: types.SMARTCHAT_ALTERNATIVES_UPDATE_LOADING,
  payload
})

const updateError = (payload) => ({
  type: types.SMARTCHAT_ALTERNATIVES_UPDATE_ERROR,
  payload
})

export {
  setAlternatives,
  updateAlternatives,
  deleteAlternatives,
  saveAlternatives,
  setAlternative,
  deleteAlternative,
  updateAlternativesButtons,
  updateAlternativesQuestion,
  updateAlternativeText,
  setAlternativesModalActionRef,
  updateAlternativesModalActionRef,
  deleteAlternativesModalActionRef,
  setAlternativesInitialActionDetail,
  setAlternativesActionDetail,
  deleteAlternativesActionDetail,
  setAlternativesActionValue,
  saveAlternativesActionDetail,
  setAlternativesActionsErrors,
  updateAlternativesActionsErrors,
  deleteAlternativesActionsErrors,
  updateModalError,
  updateLoading,
  updateError
}
